import { TYPE_STRING } from './input-types';

export const id = 'trackingNumber';
export const apiKey = 'TrackingNumber';
export const type = TYPE_STRING;

export const trackingNumber = {
  id,
  apiKey,
  type,
};
